import { takeLatest, put, call } from "redux-saga/effects";
import {
  GET_FAQ,
  ADD_FAQ,
  UPDATE_FAQ,
  DELETE_FAQ,
} from "./actionTypes";
import {
  getFaqSuccess,
  getFaqFail,
  addFaqSuccess,
  addFaqFail,
  updateFaqSuccess,
  updateFaqFail,
  deleteFaqSuccess,
  deleteFaqFail,
} from "./actions";
import {
  apiGetFaqs,
  apiPutFaq,
  apiPatchFaq,
  apiDelFaq,
} from "../../helpers/api/master/faqs";

function* onGetFaq(payload) {
  try {
    const response = yield call(apiGetFaqs, payload?.payload);
    if (response) yield put(getFaqSuccess(response));
  } catch (error) {
    if (error?.response?.status === 401) {
      onGetFaq(payload);
    }
    yield put(getFaqFail(error?.data?.error || { code: 400 }));
  }
}

function* onAddFaq(payload) {
  try {
    const response = yield call(apiPutFaq, payload?.payload);
    const responseGet = yield call(apiGetFaqs);
    if (response && responseGet) {
      yield put(
        addFaqSuccess({
          message: response.data?.message || "",
          type: "ADD",
        })
      );
      yield put(getFaqSuccess(responseGet));
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      onAddFaq(payload);
    }
    yield put(addFaqFail(error?.data?.error || { code: 400 }));
  }
}

function* onUpdateFaq(payload) {
  try {
    const response = yield call(
      apiPatchFaq,
      payload?.payload.id,
      payload?.payload.data
    );
    const responseGet = yield call(apiGetFaqs);
    if (response && responseGet) {
      yield put(
        updateFaqSuccess({
          message: response.data?.message || "",
          type: "UPDATE",
        })
      );
      yield put(getFaqSuccess(responseGet));
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      onUpdateFaq(payload);
    }
    yield put(updateFaqFail(error?.data?.error || { code: 400 }));
  }
}

function* onDeleteFaq(payload) {
  try {
    const response = yield call(apiDelFaq, payload?.payload);
    const responseGet = yield call(apiGetFaqs);
    if (response && responseGet) {
      yield put(
        deleteFaqSuccess({
          message: response.data?.message || "",
          type: "DELETE",
        })
      );
      yield put(getFaqSuccess(responseGet));
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      onDeleteFaq(payload);
    }
    yield put(deleteFaqFail(error?.data?.error || { code: 400 }));
  }
}

function* FaqSaga() {
  yield takeLatest(GET_FAQ, onGetFaq);
  yield takeLatest(ADD_FAQ, onAddFaq);
  yield takeLatest(UPDATE_FAQ, onUpdateFaq);
  yield takeLatest(DELETE_FAQ, onDeleteFaq);
}

export default FaqSaga;
